import React from "react";
import "./Brief.css";
import krinvyLogo from "../assets/images/krinvy_growth.gif";
import krinvybrief from "../assets/images/krinvy_brief.gif";
const Brief = () => {
  return (
    <div className="brief-container">
     <img src={krinvybrief} alt="Krinvy Logo" className="brief-logo" />
      <p className="brief-text">
        Krinvy is your trusted partner for comprehensive business solutions, offering everything from tax and compliance services to web app development, Mobile app development, AI integrations, UI & UX, branding, and digital marketing content & more. Whether you're starting in India, the U.S., or globally, we tailor our solutions to your needs. Our goal is to help you focus on your vision while we handle the operational complexities, so you can grow and scale efficiently in any market.
      </p>
      <img src={krinvyLogo} alt="Krinvy Logo" className="brief-logo" />
    </div>
  );
};

export default Brief;
